/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TimesheetType = {
    ATTENDANCE: 'ATTENDANCE',
    VACATION: 'VACATION',
    ABSENCE: 'ABSENCE',
    HOLIDAY: 'HOLIDAY',
    SICK: 'SICK',
    BONUS: 'BONUS'
} as const;
export type TimesheetType = typeof TimesheetType[keyof typeof TimesheetType];

